import { Card } from "@/components/ui/card";
import { cn } from "@/lib/utils";

export interface BookSegment {
  key: string;
  label: string;
  value: number;
  total: number;
  description: string;
  color: "green" | "orange" | "yellow" | "red";
}

interface Props {
  segments: BookSegment[];
  onSegmentClick?: (key: string) => void;
}

const BAR_COLORS: Record<BookSegment["color"], string> = {
  green: "bg-green-500",
  orange: "bg-orange-500",
  yellow: "bg-yellow-500",
  red: "bg-red-500",
};

export function BookOverview({ segments, onSegmentClick }: Props) {
  return (
    <Card className="p-6 space-y-5" data-testid="book-overview">
      <div>
        <h3 className="text-base font-semibold">Book Overview</h3>
        <p className="text-xs text-muted-foreground mt-0.5">Active book by client segment</p>
      </div>

      <ul className="space-y-4">
        {segments.map((s) => {
          const percent = s.total > 0 ? Math.min(100, (s.value / s.total) * 100) : 0;
          return (
            <li
              key={s.key}
              className="cursor-pointer"
              onClick={() => onSegmentClick?.(s.key)}
              data-testid={`book-segment-${s.key}`}
            >
              <div className="flex items-center justify-between">
                <span className="text-sm font-medium">{s.label}</span>
                <span className="text-sm font-semibold">{s.value}</span>
              </div>
              <div className="h-1.5 bg-muted rounded-full overflow-hidden mt-1.5">
                <div
                  className={cn("h-full rounded-full", BAR_COLORS[s.color])}
                  style={{ width: `${percent}%` }}
                />
              </div>
              <p className="text-xs text-muted-foreground mt-1.5">{s.description}</p>
            </li>
          );
        })}
      </ul>
    </Card>
  );
}
